import React, { Component } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Book from '../containers/BookContainer';
import Chapter from '../containers/ChapterContainer';
import Login from '../containers/LoginContainer';
import Profile from '../containers/ProfileContainer';
import MainMenu from '../containers/MainMenuContainer';
import NoMatch from './NoMatch';
import BookLoader from '../containers/BookLoaderContainer';
import Page from '../containers/PageContainer';
import NoBook from './NoBook';
import NoAccess from '../containers/NoAccessContainer';
import Register from '../containers/RegisterContainer';
import findIdByPath from '../utils/findIdByPath';
import findAccess from '../utils/findAccess';
import RegisterKey from '../containers/RegisterKeyContainer';

class App extends Component {
  componentDidMount() {
    this.setBodyThemeColor();
  }

  setBodyThemeColor() {
    const body = document.body;
    const { theme } = this.props;

    body.style.backgroundColor = theme.primary;
  }

  componentDidUpdate(props) {
    const body = document.body;
    const { theme } = this.props;

    if (props.theme !== this.props.theme) {
      body.style.backgroundColor = theme.primary;
    }
  }

  render() {
    const { user, theme } = this.props;
    const { loggedIn, userData } = user;
    const bookId = findIdByPath();
    const myAccessedBooks = userData && userData.books ? userData.books : null;
    const currentAccessLevel =
      userData && userData.permissions ? userData.permissions : 0;
    const hasAccess = findAccess(
      myAccessedBooks,
      bookId,
      loggedIn,
      currentAccessLevel
    );

    return (
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <div>
            <MainMenu />
            {loggedIn && <BookLoader loggedIn={loggedIn} />}
            {loggedIn ? (
              <div>
                {!hasAccess ? (
                  <Switch>
                    <Route exact path="/" component={NoBook} />
                    <Route
                      exact
                      path="/404"
                      render={props => (
                        <NoMatch loggedIn={loggedIn} {...props} />
                      )}
                    />
                    <Route component={NoAccess} />
                  </Switch>
                ) : (
                  <Switch>
                    <Route exact path="/" component={NoBook} />
                    <Route exact path="/bok/:bookId" component={Book} />
                    <Route
                      exact
                      path="/bok/:bookId/kapittel/:chapterId"
                      render={props => (
                        <Chapter
                          key={props.match.params.chapterId}
                          {...props}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/bok/:bookId/min-side"
                      component={Profile}
                    />
                    <Route
                      exact
                      path="/bok/:bookId/om-mitt-valg"
                      render={() => (
                        <Page key="om-mitt-valg" slug="om-mitt-valg" />
                      )}
                    />
                    <Route
                      exact
                      path="/bok/:bookId/kontakt-oss"
                      render={() => (
                        <Page key="kontakt-oss" slug="kontakt-oss" />
                      )}
                    />
                    <Route
                      exact
                      path="/bok/:bookId/logg-inn"
                      render={props => (
                        <Redirect to={`/bok/${props.match.params.bookId}`} />
                      )}
                    />
                    <Route
                      render={props => (
                        <NoMatch loggedIn={loggedIn} {...props} />
                      )}
                    />
                  </Switch>
                )}
              </div>
            ) : (
              <Switch>
                <Route
                  path="/bok/:bookId/logg-inn"
                  render={props => (
                    <Login {...props} key={props.history.location.key} />
                  )}
                />
                <Route
                  exact
                  path="/bok/:bookId/registrer"
                  render={props => <Register register {...props} />}
                />
                <Route
                  exact
                  path="/bok/:bookId/ny-lisens"
                  render={props => <RegisterKey {...props} />}
                />
                <Route
                  path="/*"
                  render={props => {
                    if (bookId) {
                      return (
                        <Redirect
                          to={`/bok/${findIdByPath()}/logg-inn`} // Denne id'en finnnes ikke gjennom props.match.params :(
                        />
                      );
                    }

                    return <NoBook />;
                  }}
                />
              </Switch>
            )}
          </div>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js